import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const updateCandidateStatus = createAsyncThunk(
  "candidates/updateCandidateStatus",
  async (statusData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.updatecandidateresumestatus,
        statusData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteCandidate = createAsyncThunk(
  "candidates/deleteCandidate",
  async (statusData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.deletecandidateafterconfirmation,
        statusData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const candidateStatusSlice = createSlice({
  name: "candidates",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCandidateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateCandidateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCandidate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCandidate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteCandidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default candidateStatusSlice.reducer;
